import { Component, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import { Event } from '@angular/router';
import { AppService } from 'src/app/core/services/app.service';
import { UserService } from 'src/app/core/services/user.service';
import { TableColumn, TableDataModel } from '../../models/CommandCenterUI/TableDataModel.model';

@Component({
	selector: 'app-table-column-picker',
	templateUrl: './table-column-picker.component.html',
	styleUrls: ['../../../modules/online-order/online-order.component.scss'],
})
export class TableColumnPickerComponent implements OnInit, OnDestroy, OnChanges {
	@Input() tableModel: TableDataModel;

	@Output() modelChange: Event;

	selectedColumns: TableColumn[] = [];

	constructor(public app: AppService, public userService: UserService) {}
	ngOnChanges(changes: SimpleChanges): void {
		if (changes.tableModel && changes.tableModel.previousValue?.columns.length === 0) {
			console.log(`initial column pick load`);
			this.loadInitialColumns(this.tableModel.columns);
		}
	}

	ngOnDestroy(): void {
		this.selectedColumns = [];
	}

	ngOnInit(): void {}

	loadInitialColumns(tableColumns: TableColumn[]) {
		this.selectedColumns = tableColumns.filter((col) => col.display);
	}

	selectColumns() {
		this.tableModel.columns.forEach((column) => {
			if (this.selectedColumns.some((i) => i.dataProperty === column.dataProperty)) {
				column.display = true;
			} else {
				column.display = false;
			}
		});

		this.userService.setColumnPreferences(this.tableModel.sk, this.tableModel.columns);
		//do usercolumn preference save here
	}
}
